import { render, staticRenderFns } from "./SideNavLoggedIn.vue?vue&type=template&id=083cdf95&scoped=true&"
import script from "./SideNavLoggedIn.vue?vue&type=script&lang=ts&"
export * from "./SideNavLoggedIn.vue?vue&type=script&lang=ts&"
import style0 from "./SideNavLoggedIn.vue?vue&type=style&index=0&id=083cdf95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cdf95",
  null
  
)

export default component.exports